import { render, staticRenderFns } from "./FightersPreloader.vue?vue&type=template&id=3960d956&lang=pug&"
import script from "./FightersPreloader.vue?vue&type=script&lang=js&"
export * from "./FightersPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports